// extracted by mini-css-extract-plugin
module.exports = {"buttonContainer":"MostActiveUsersSection_buttonContainer__Xe7NO","userGrid":"MostActiveUsersSection_userGrid__3KghY"};